/**
 * 自动化任务模块
 * 
 * 任务管理、文件编辑、运行控制、日志查看
 */

import type { WorkbenchModule } from '../types'

export const tasksModule: WorkbenchModule = {
  meta: {
    name: 'tasks',
    title: '自动化任务',
    description: '任务管理、定时调度、文件编辑、运行日志',
    version: '0.1.0'
  },
  routes: [
    {
      path: '/tasks',
      name: 'tasks',
      component: () => import('./views/TaskListView.vue'),
      meta: { title: '任务列表' }
    },
    {
      path: '/tasks/:id',
      name: 'task-detail',
      component: () => import('./views/TaskDetailView.vue'),
      meta: { title: '任务详情' }
    },
    {
      path: '/tasks/:id/edit',
      name: 'task-edit',
      component: () => import('./views/TaskEditView.vue'),
      meta: { title: '编辑任务' }
    },
    {
      path: '/tasks/:id/files',
      name: 'task-files',
      component: () => import('./views/TaskFilesView.vue'),
      meta: { title: '任务文件' }
    },
    {
      path: '/tasks/:id/logs',
      name: 'task-logs',
      component: () => import('./views/TaskLogsView.vue'),
      meta: { title: '任务日志' }
    }
  ],
  menuItem: {
    id: 'tasks',
    label: '自动化任务',
    path: '/tasks',
    icon: 'tasks',
    order: 40
  }
}
